export default __webpack_public_path__ + "media/templatesNotFound.25278ee6.png";